const modalNavigation = () => {
  // I dont even
};

export default modalNavigation;



// WEBPACK FOOTER //
// ./scripts/modal-navigation.js